module.exports = "/cyber/_next/static/images/vesenniiRozygryshItogi-d97c86da599d02b25302074d59b11779.jpg";